"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelAppointmentFooter = exports.CancelAppointmentBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const dayjs_1 = __importDefault(require("dayjs"));
const LoadingButton_1 = __importDefault(require("../../../components/LoadingButton"));
const axios_1 = __importDefault(require("axios"));
const CancelAppointmentBody = ({ appointment, status, }) => {
    const { fromDate, location } = appointment;
    const modalBody = (0, react_1.useMemo)(() => {
        switch (status) {
            case 'OK':
                return (0, jsx_runtime_1.jsx)("h4", { children: __.trans('booking.cancellation-success') });
            case 'ERROR':
                return (0, jsx_runtime_1.jsx)("h4", { className: "text-danger", children: __.trans('booking.cancellation-error') });
            default:
                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h4", { children: __.trans('booking.modal-time') }), (0, jsx_runtime_1.jsx)("p", { className: "capitalize", children: `${(0, dayjs_1.default)(fromDate).format('dddd D MMMM YYYY')}, kl. ${(0, dayjs_1.default)(fromDate).format('HH:mm')}` })] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h4", { children: __.trans('booking.blood-central') }), (0, jsx_runtime_1.jsx)("p", { children: location.name })] }), (0, jsx_runtime_1.jsx)("div", { className: "booking-info-text", children: (0, jsx_runtime_1.jsx)("p", { children: __.trans('booking.modal-info-cancelation-text') }) })] }));
        }
    }, [status, fromDate, location.name]);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: modalBody });
};
exports.CancelAppointmentBody = CancelAppointmentBody;
const CancelAppointmentFooter = ({ appointment, toggleBookingModal, setIsLoading, handleStatusChange, isLoading, status, }) => {
    const { canCancel, appointmentId } = appointment;
    const cancelAppointment = () => {
        setIsLoading(true);
        axios_1.default
            .post('/api/booking/cancel-appointment', {
            existingAppointmentId: appointmentId,
        })
            .then((response) => {
            handleStatusChange(response.data.replyStatus.status);
        })
            .catch((error) => {
            handleStatusChange(error.response.data.replyStatus.status);
        });
    };
    const handleClose = () => {
        handleStatusChange(undefined);
        toggleBookingModal();
    };
    return canCancel ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: status ? ((0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-sm theme-button-primary", onClick: handleClose, children: __.trans('app.general_close') })) : ((0, jsx_runtime_1.jsx)(LoadingButton_1.default, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-sm theme-button-primary", onClick: cancelAppointment, children: __.trans('booking.cancel') }) })) })) : null;
};
exports.CancelAppointmentFooter = CancelAppointmentFooter;
